<div class="modal-header align-items-center text-primary pb-1">
	<div>
		<h3 class="font-weight-bold  mb-1" *ngIf="!board?.id">Add Image</h3>
		<h3 class="font-weight-bold  mb-1" *ngIf="board?.id">Change Image</h3>
		<!-- <div class="text-small text-danger" *ngIf="board?.id">board: {{board.id}}</div>  -->
	</div>
    <button type="button" class="modal-close ml-auto" aria-label="Close" (click)="closeModal()"><fa-icon [icon]="['fas', 'times']"></fa-icon></button>
</div>
<div class="modal-body text-primary pt-1">

	<div class="mb-3">
		<form 
			*ngIf="boardForm"
			[formGroup]="boardForm" 
			(ngSubmit)="onSubmit()" 
			>
			<input type="hidden" formControlName="id" />
			
			<div class="my-2">
				<div class="file-uploader-row mb-2">
					<label class="form-label mb-1"><span>Upload Travel Board Image</span></label>
					<div class="d-flex align-items-center">
						<div class="custom-file">
							<label class="custom-file-label" for="asset"><span>{{asset?.name}}</span></label>
							<input type="file" class="custom-file-input" id="asset" formControlName="asset" onclick="value=null" (change)="onUpload($event)" accept="image/*">
						</div>
						<div class="btn btn-link text-danger d-flex ml-3 pr-0">
							<fa-icon [icon]="['fas', 'trash-alt']" class="mr-2"></fa-icon><span>Remove</span>
						</div>
					</div>
				</div>
			</div>


			<button type="submit" 
				class="btn btn-quinary btn-save pill font-weight-bold px-4"
				[disabled]="false">Save Board</button>

			<app-response-message [responseMsg]="responseMsg" *ngIf="responseMsg"></app-response-message>
		</form>

		<ng-template #noboards>Travel Board not found.</ng-template>
	</div>


</div>
<!-- <div class="modal-footer">
    
	
</div> -->



<!-- <div class="text-small text-danger">productId: {{productId}}</div>  -->